import React, { useState, useContext } from "react";
import { Field } from "formik";
import { isEmpty } from "lodash";
import { faPencilAlt } from "@fortawesome/pro-light-svg-icons";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FieldInputDollar,
  FieldButtonGroup,
  AddButton,
  AddPlans,
  CsplTable as Table,
  SliderPanel,
} from "../../../../../components";
import {
  yesNoOptions,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  getNullTableItem,
} from "../../../../../utils";
import { manageRkaasStore } from "../../../../../contexts";
import AddMarketTimingRules from "./AddMarketTimingRules";

const columns = [
  {
    label: "Road trip occurance",
    className: "column-road-trip-occurance",
    columnName: "roadTripOccurance",
  },
  {
    label: "Days between transfer",
    className: "column-days-between-transfer",
    columnName: "daysBetweenTransfer",
  },
  {
    label: "Failed rule result",
    className: "column-failed-rule-result",
    columnName: "failedRuleResult",
  },
  {
    label: "Number of days to block future transfers",
    className: "column-block-future-transfers",
    columnName: "daysToBlockFutureTransfers",
  },
  {
    label: "Action",
    className: "column-action",
    columnName: "action",
  },
];

const failedRuleResult = {
  data: [
    "",
    "Warn participant",
    "Block transaction",
    "Block future transaction",
  ],
};

const MarketTimingRulesFields = (props) => {
  const { state, dispatch } = useContext(manageRkaasStore);
  const {
    fields,
    values,
    setFieldValue,
    isEdit,
    isSave,
    handleChange,
    marketTimingRules,
    setMarketTimingRules,
    isInnerFormDirty,
    setIsInnerFormDirty,
    setTabGrey,
    errorList,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [data, setData] = useState({});

  const addMarketTimingRuleClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  const deleteMarketRule = (id) => {
    setMarketTimingRules(
      marketTimingRules
        .filter((_) => id != _.roadTripOccurance)
        .map((item, i) => {
          return {
            ...item,
            roadTripOccurance: i + 1,
          };
        })
    );
  };

  return (
    <>
      <div>
        <Field
          size="sm"
          name={fields.applyMarketTiming}
          label={"Apply market timing rules"}
          isRequired
          options={yesNoOptions}
          selectedValue={values[fields.applyMarketTiming]}
          value={values[fields.applyMarketTiming]}
          onChange={(value) => {
            setTabGrey(3);
            !value && setMarketTimingRules([]);
            setFieldValue(fields.applyMarketTiming, value);
            setFieldValue(fields.roadTripOccuranceDefinition, null);
            setFieldValue(fields.excludeDollor, null);
          }}
          component={FieldButtonGroup}
          disabled={isEdit && !isSave}
        />
        {values[fields.applyMarketTiming] && (
          <>
            <Field
              isRequired
              name={fields.roadTripOccuranceDefinition}
              label="Road trip occurance definition"
              options={toOptionValuesFromMapper(
                OPTIONS_DATA_MAPPER.ROAD_TRIP_OCCURANCE_DEFINITION
              )}
              selectedValue={values[fields.roadTripOccuranceDefinition]}
              onChange={(value) => {
                setTabGrey(3);
                setFieldValue(fields.roadTripOccuranceDefinition, value);
              }}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="xl"
            />
            <Field
              name={fields.excludeDollor}
              label="Exclude dollor specific transaction lesser than"
              preventNegative
              isRequired
              type="number"
              autoComplete="off"
              min={0}
              max={9999.99}
              value={values[fields.excludeDollor]}
              onChange={(e) => {
                setTabGrey(3);
                handleChange(e);
              }}
              disabled={isEdit && !isSave}
              component={FieldInputDollar}
            />
            <div className="line-separator" />
            <div className="d-flex justify-content-between bg-title">
              <div>
                <h4 className="ft-20">Market timing rules</h4>
              </div>
              <div>
                <AddButton
                  menu="rkaas"
                  subMenu="investment"
                  onAddClick={addMarketTimingRuleClick}
                  disabled={isEdit && !isSave}
                />
              </div>
            </div>
            {isEmpty(marketTimingRules) ? (
              <AddPlans
                menu="rkaas"
                subMenu="investment"
                content="No Market timing rules"
                buttonLabel="Add Market Timing Rules"
                className="h-auto"
                disabled={isEdit && !isSave}
                onPrimaryClick={addMarketTimingRuleClick}
                errorList={errorList}
              />
            ) : (
              <div className="market-timing-table w-100">
                <Table>
                  <Table.Thead>
                    <Table.Tr>
                      {columns.map((item, index) => {
                        return (
                          <Table.Th key={index} className={item.className}>
                            {item.label}
                          </Table.Th>
                        );
                      })}
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {marketTimingRules.map((marketTimingRule, index) => {
                      return (
                        <>
                          <Table.Tr key={index}>
                            {columns.map((item, cellIndex) => {
                              const getContent = () => {
                                if (item.columnName == "action") {
                                  return [
                                    <FontAwesomeIcon
                                      icon={faPencilAlt}
                                      size="lg"
                                      color="#3a3974"
                                      className={
                                        isEdit
                                          ? "cursor-not-allowed"
                                          : "pointer"
                                      }
                                      disabled={isEdit && !isSave}
                                      onClick={() => {
                                        if (!isEdit) {
                                          setEdit(true);
                                          setData(marketTimingRule);
                                          addMarketTimingRuleClick();
                                        }
                                      }}
                                    />,

                                    <span>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>,

                                    <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      size="lg"
                                      color="#ff5050"
                                      className={
                                        isEdit
                                          ? "cursor-not-allowed"
                                          : "pointer"
                                      }
                                      disabled={isEdit && !isSave}
                                      onClick={() => {
                                        if (!isEdit)
                                          deleteMarketRule(
                                            marketTimingRule.roadTripOccurance
                                          );
                                      }}
                                    />,
                                  ];
                                }
                                if (item.columnName == "failedRuleResult") {
                                  return failedRuleResult.data[
                                    marketTimingRule[item.columnName]
                                  ];
                                }
                                return marketTimingRule[item.columnName];
                              };
                              return (
                                <Table.Td
                                  key={cellIndex}
                                  className={item.className}
                                >
                                  {getNullTableItem(getContent())}
                                </Table.Td>
                              );
                            })}
                          </Table.Tr>
                        </>
                      );
                    })}
                  </Table.Tbody>
                </Table>
              </div>
            )}
          </>
        )}
      </div>

      <SliderPanel
        isOpen={isModalOpen}
        size="55"
        showCancel={false}
        // backdropClicked={() => {
        //   setEdit(false);
        //   addMarketTimingRuleClick();
        // }}
      >
        <AddMarketTimingRules
          {...props}
          data={data}
          edit={edit}
          setEdit={setEdit}
          marketTimingRules={marketTimingRules}
          setMarketTimingRules={setMarketTimingRules}
          errorList={errorList}
          {...{ isInnerFormDirty, setIsInnerFormDirty }}
          addMarketTimingRuleClick={addMarketTimingRuleClick}
          setTabGrey={setTabGrey}
        />
      </SliderPanel>
    </>
  );
};

export default MarketTimingRulesFields;
